import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { CSSProperties } from 'react';

export const DemoContent = styled.div`
  padding: 40px;
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  p {
    max-width: 600px;
  }
`;

export const DemoProducts = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;
  margin-top: 32px;
`;

export const DemoProductButton = styled(Link)`
  box-shadow: 0 0 4px rgb(0 0 0 / 14%);
  padding: 24px 16px 40px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 33%;
  justify-content: center;
  align-items: center;
  color: var(--colorBlueGray1300);
  text-decoration: none;
  position: relative;
  background-color: var(--colorWhite);

  span {
    font-weight: 600;
    margin-top: 8px;
  }

  em {
    font-style: normal;
    font-size: 14px;
    color: var(--colorBlueGray900);
  }
`;

export const ArrowIcon = styled.img`
  position: absolute;
  bottom: 8px;
  right: 8px;
`;

export const ExitButton = styled.button`
  padding: 8px;
  margin-top: 24px;
  color: var(--colorBlueGray1300);
  text-decoration: underline;
  background-color: transparent;
  border: none;
  outline: none;
  font-size: 14px;
  letter-spacing: 1px;
`;
